import style from "./style.module.scss";
import Chart from "react-apexcharts";
import React from "react";
import ComparisonDashDoubledChard from "../UI/ComparisonDashDoubledChard";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/styles"
import config from "../../../config"
import { useSelector } from "react-redux"

export const PreLoaderCont = ({
  id,
  title,
  subTitle,
  text,
  color,
  label,
  value,
  lTitle,
  lCount,
  lText,
  lCountMax,
  withLinear,
  textsComp,
  combine
}) => {
  const {theme: {bgColors, colors, borderColors}} = useTheme()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const chartOptions = {
    plotOptions: {
      radialBar: {
        hollow: {
          size: "65%",
        },
        track: {
          background: bgColors.bgRadial,
        },
        dataLabels: {
          showOn: "always",
          name: {
            offsetY: -20,
            show: true,
            color: colors.colorMutedText,
            fontSize: "20px",
            fontWeight: 800
          },
          value: {
            show: false
          }
        }
      }
    },
    stroke: {
      lineCap: "round"
    },
    labels: [label],
    fill: {
      opacity: 1.5,
      type: 'gradient',
      colors: [isContrast ? bgColors.bgCockpitBar : color],
      gradient: {
        gradientToColors: [isContrast ? bgColors.bgCockpitBar : color],
        stops: [0, 50, 100],
        inverseColors: false
      }
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        }
      }
    }
  };

  const { t } = useTranslation();

  return (
    <div className={style.preloaderCont}>
      {combine ?
        <>
          <br />
          <h3 style={{ color: colors.colorText }}>{title}</h3>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className={`d-flex align-items-start flex-lg-row flex-md-column`} style={{ gridGap: "30px" }}>
              <div className={`${style.mainDesc} p-0 pt-4 ${(withLinear || textsComp) && `${style.withLinearCont}`} w-100`}>
                <div className={style.loader}>
                  <span style={{ position: "relative" }}>
                    <p className={style.loaderValue1} style={{
                      color: isContrast ? colors.colorText : color,
                      position: "absolute",
                      top: "80px",
                      left: "150px",
                      fontSize: "50px",
                      fontWeight: "bolder",
                      transform: "translateX(-50%)"
                    }}>{value}%</p>
                    <Chart type="radialBar" series={[value]} options={chartOptions} width={300} />
                  </span>
                </div>
              </div>
            </div>
            <div>
              <div className={style.lDesc} style={{ color: colors.colorText }}>
                <p className={style.lCount}><b style={{ color: isContrast ? colors.colorText : color }}>{lCount} </b>
                  {t('from')}
                  <b style={{ color: colors.colorText }}> {lCountMax}</b></p>
                <b>
                  {
                    combine ?
                      <h4>
                        {lTitle}
                      </h4> :
                      <>
                        {lTitle}
                      </>
                  }
                </b>
                {/* <h2 className={style.lTitle}></h2> */}
                {lText.map((t, i) => <div key={i} dangerouslySetInnerHTML={{ "__html": t }} />)}
              </div>
              {
                withLinear &&
                <div className={`w-100`}>
                  <ComparisonDashDoubledChard seriesNames={['preloader']} chartContent={{
                    withChartTypes: false,
                    withTimeInterval: true,
                    withTotalOver: false
                  }} chartId={`HIX_PAGEs-${id}`} />
                </div>
              }
            </div>
            <div style={{ width: "40%" }}>
              <div style={{ color: colors.colorText }} className={`${style.desc}`}>
                <h4>{subTitle}</h4>
                {text.map((t, i) => <div style={{ overflowWrap: "anywhere" }} key={i} dangerouslySetInnerHTML={{ "__html": t }} />)}
              </div>
            </div>
          </div>
        </>
        :
        <><h3 style={{ color: colors.colorText }}>{title}</h3>
          <div className={`d-flex align-items-start flex-lg-row flex-md-column`} style={{ gridGap: "30px" }}>
            <div className={`${style.mainDesc} p-0 pt-4 ${(withLinear || textsComp) && `${style.withLinearCont}`} w-100`}>
              <div className={style.loader}>
                <span style={{ position: "relative" }}>
                  <Chart type="radialBar" series={[value]} options={chartOptions} width={300} 
                  />
                  <p className={style.loaderValue} style={{ color: isContrast ? colors.colorText : color }}>{value}%</p>
                </span>

                <div className={style.lDesc} style={{ color: colors.colorText }}>
                  <p className={style.lCount}><b style={{ color: isContrast ? colors.colorText : color }}>{lCount} </b>
                    {t('from')}
                    <b> {lCountMax}</b></p>
                  <h2 className={style.lTitle}>{lTitle}</h2>
                  {lText.map((t, i) => <div key={i} dangerouslySetInnerHTML={{ "__html": t }} />)}
                </div>
              </div>
            </div>
            {
              withLinear &&
              <div className={`w-100`}>
                <ComparisonDashDoubledChard seriesNames={['preloader']} chartContent={{
                  withChartTypes: false,
                  withTimeInterval: true,
                  withTotalOver: false
                }} chartId={`HIX_PAGEs-${id}`} />
              </div>
            }
          </div>
          <div style={{ color: colors.colorText }} className={`${style.desc}`}>
            <h4>{subTitle}</h4>
            {text.map((t, i) => <div style={{ overflowWrap: "anywhere" }} key={i} dangerouslySetInnerHTML={{ "__html": t }} />)}
          </div>
        </>
      }
    </div>
  );
}
